import api from "./api";

export async function checkIfUserEmailExists(
    email: string
): Promise<any | null> {
    return await api
        .get("/api/user-email-exists/" + email)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function getCurrentUser(): Promise<any | null> {
    return await api
        .get("/api/current-user/")
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function patchUser(
    id: number | null,
    data: any
): Promise<any | null> {
    return await api
        .patch("/api/user/" + id, data)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function getUser(id: number | null): Promise<any | null> {
    return await api
        .get("/api/user/" + id)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function getUsers(userIds: number[]): Promise<any | null> {
    return await api
        .get("/api/user/?userIds=" + userIds)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function getUserByEstablishmentId(establishementId: number): Promise<any | null> {
    
    return await api
        .get(`api/users/?establishment_id=${establishementId}`)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}